//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import { colors } from "quasar";

import QFabricModal from "../../q-fabric-modal.vue";

const { setBrand, hexToRgb } = colors;

export default {
    name: "QfMThemes",
    components: { QFabricModal },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            showPicker: false,
            pickerColor: null,
            localShow: true,
            currentColor: null,
            actions: [{ label: "Close", name: "close", disable: false }]
        };
    },
    computed: {
        ...mapState("components", ["defaultColors", "colorValue", "pageReference"]),
        editableColors() {
            const colorsArr = [];

            this.defaultColors.forEach(color => {
                if (color.theme) {
                    colorsArr.push({ label: color.label, value: color.value });
                }
            });

            return colorsArr;
        }
    },
    watch: {
        showPicker(val) {
            if (!val) {
                this.currentColor = null;
            }
        }
    },
    methods: {
        ...mapMutations("components", ["updateColor", "resetColors"]),
        classes(color) {
            return this.currentColor === color.value ? "active" : null;
        },
        style(color) {
            const hexa = this.colorValue[color.value].value;
            const { r, g, b } = hexToRgb(hexa);
            const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

            return {
                backgroundColor: this.colorValue[color.value].value,
                color: yiq >= 128 ? "black" : "white"
            };
        },
        onColorClick(color) {
            this.currentColor = color.value;
            this.showPicker = true;
            this.pickerColor = this.colorValue[color.value].value;
        },
        cancelColorPicker() {
            this.showPicker = false;
        },
        setPickColor() {
            this.updateColor({ color: this.currentColor, value: this.pickerColor });
            setBrand(this.currentColor, this.pickerColor, this.pageReference);
            this.showPicker = false;
            this.$root.$emit("showCheckedSaveBtn", false);
        },
        resetColorPicker() {
            const defaultColor = this.colorValue[this.currentColor].default;
            this.updateColor({ color: this.currentColor, value: defaultColor });
            setBrand(this.currentColor, defaultColor, this.pageReference);
            this.pickerColor = defaultColor;
        },
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = false;
            } else if (action.simple === "action") {
                if (action.detailed === "close") {
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        modalAfterShow() {
            const vm = this;
            this.$refs.upload.addEventListener("change", function () {
                const files = this.files || [];
                if (files.length) {
                    vm.$loadFile(files[0]).then(data => {
                        const colorsParse = JSON.parse(data);
                        Object.entries(colorsParse).forEach(([color, value]) => {
                            vm.updateColor({ color, value });
                            setBrand(color, value, vm.pageReference);
                        });
                    });
                }
            });
        },
        reset() {
            Object.entries(this.colorValue).forEach(([key, data]) => {
                this.updateColor({ color: key, value: data.default });
                setBrand(key, data.default, this.pageReference);
            });
        },
        download() {
            const colorsObj = {};
            Object.entries(this.colorValue).forEach(([key, data]) => {
                colorsObj[key] = data.value;
            });
            this.$saveFileAs("theme.json", JSON.stringify(colorsObj));
        }
    }
};
